import React from 'react';

type Props = {
  value: string;
  showArchive: boolean;
  onChange: (value: string) => void;
  onArchiveChange: (showArchive: boolean) => void;
  onFocus?: () => void;
  onClear?: () => void;
  resultCount?: number;
};

export default function ProgramsSearch({
  value,
  showArchive,
  onChange,
  onArchiveChange,
  onFocus,
  onClear,
  resultCount,
}: Props) {
  const hasValue = !!value.trim();

  return (
    <div className="programs-search">
      <div className="programs-search__head">
        <div className="programs-search__heading">
          <h1 className="programs-search__title">Programas</h1>

          <div
            className="programs-search__filters"
            role="group"
            aria-label="Filtrar programas"
          >
            <span
              className={[
                'programs-search__indicator',
                showArchive ? 'programs-search__indicator--archive' : '',
              ]
                .filter(Boolean)
                .join(' ')}
              aria-hidden="true"
            />
            <button
              type="button"
              className={[
                'programs-search__filter',
                !showArchive ? 'programs-search__filter--active' : '',
              ]
                .filter(Boolean)
                .join(' ')}
              aria-pressed={!showArchive}
              onClick={() => onArchiveChange(false)}
            >
              No ar
            </button>

            <button
              type="button"
              className={[
                'programs-search__filter',
                showArchive ? 'programs-search__filter--active' : '',
              ]
                .filter(Boolean)
                .join(' ')}
              aria-pressed={showArchive}
              onClick={() => onArchiveChange(true)}
            >
              Acervo
            </button>
          </div>
        </div>

        <div className="programs-search__field">
          <span className="programs-search__icon" aria-hidden="true">
            ⌕
          </span>

          <input
            type="text"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            onFocus={onFocus}
            placeholder="Digite o nome do programa"
            aria-label="Buscar programa pelo nome"
          />

          {hasValue ? (
            <button
              type="button"
              className="programs-search__clear"
              onClick={onClear}
              aria-label="Limpar busca"
              title="Limpar busca"
            >
              ×
            </button>
          ) : null}
        </div>

        {typeof resultCount === 'number' ? (
          <p className="programs-search__result" aria-live="polite">
            {resultCount === 1
              ? '1 programa encontrado'
              : `${resultCount} programas encontrados`}
          </p>
        ) : null}
      </div>
    </div>
  );
}
